import React from 'react';

const Visa = (props: object) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="10"
      viewBox="0 0 31 10"
      fill="none"
      {...props}
    >
      <path
        d="M28.6108 9.85565L28.3296 8.40595H25.0321L24.5321 9.84535L21.9683 9.8505C23.6208 5.83935 24.8225 2.86812 25.5733 0.936855C25.7816 0.431702 26.1754 0.173969 26.7545 0.177836C27.1216 0.180272 27.7908 0.180701 28.7621 0.179123L30.6666 9.85180L28.6108 9.85565ZM25.7266 6.42010H27.7529L27.0966 2.78608L25.7266 6.42010ZM9.08583 0.176547L11.6933 0.179123L7.77833 9.85695L5.14583 9.85437C4.57156 7.29810 4.00156 4.73966 3.43583 2.17912C3.31 1.66882 3.06541 1.31186 2.45416 1.14304C1.93 0.99270 1.15583 0.76031 0.133331 0.445876V0.179123H4.37958C5.08041 0.179123 5.48833 0.52835 5.60291 1.24485C5.71875 1.96306 6.08541 3.79038 6.70291 6.72680L9.08583 0.176547ZM15.2733 0.179123L13.1721 9.85565L10.7608 9.85180L12.8583 0.176547L15.2733 0.179123ZM20.2941 0C20.9821 0 21.9908 0.231959 22.3133 0.445876L22.0908 2.45103C21.6183 2.25516 20.8408 1.99098 20.1871 2C19.2371 2.01675 18.6496 2.42784 18.6496 2.82217C18.6496 3.46392 19.6696 3.78737 20.7196 4.4884C21.9171 5.28735 22.0758 6.00515 22.0608 6.78610C22.0446 8.40335 20.7196 10 17.9246 10C16.6496 9.98065 16.1896 9.87115 15.1496 9.48970L15.5896 7.39690C16.6496 7.85310 17.0971 7.9987 18.0021 7.9987C18.8308 7.9987 19.5421 7.65335 19.5483 7.05155C19.5521 6.62370 19.2983 6.41110 18.4683 5.88275C17.6383 5.35440 15.9333 4.62114 15.9508 3.14820C15.9721 1.26418 17.6033 0 20.2941 0Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Visa;
